// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".invalid[data-v-3e3cdae2]{padding:0;border:1px solid #dd4b39;border-radius:5px}", ""]);
// Exports
module.exports = exports;
